var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 btn secondary btn-misc",on:{"click":function($event){return _vm.$modal.show('add-jewel-modal', {
            data: {},
        })}}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"fas fa-chevron-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }